@reference "~/styles.css";

@layer components {
	.content {
		@apply px-2 py-1.5 rounded-sm break-on-word text-left text-sm text-grey-100 bg-grey-900/90 shadow-tooltip;
		@apply animate-fade-in state-closed:animate-fade-out;
		/* https://www.radix-ui.com/primitives/docs/components/tooltip#constrain-the-content-size */
		@apply max-w-(--radix-tooltip-content-available-width) max-h-(--radix-tooltip-content-available-height) overflow-x-clip overflow-y-auto;
		/* https://www.radix-ui.com/primitives/docs/components/tooltip#collision-aware-animations */
		@apply origin-(--radix-tooltip-content-transform-origin);

		&.widthMax {
			@apply max-w-(--radix-tooltip-trigger-width);
		}

		&.widthMin {
			@apply min-w-(--radix-tooltip-trigger-width);
		}

		&.widthSame {
			@apply w-(--radix-tooltip-trigger-width);
		}
	}

	.arrow {
		@apply fill-grey-900/90;
	}
}
